import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { usePitcherGameLog } from "../../hooks/use-pitcher-game-log";

const fmt = (val) => {
  if (val == null || val === "") return "—";
  const n = Number(val);
  if (isNaN(n)) return "—";
  return n.toFixed(3);
};

export const PitcherGameLog = memo(({ playerId, division }) => {
  const { allGames, games, loading, error, selectedYear, setSelectedYear, availableYears } =
    usePitcherGameLog({ playerId, division });
  const navigate = useNavigate();

  if (loading) return <div className="text-center py-4" />;
  if (error) return null;
  if (allGames.length === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 mt-8 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-800">Game Log</h3>
        {availableYears.length > 1 && (
          <select
            value={selectedYear ?? ""}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="text-xs border border-gray-200 rounded-md px-2 py-1 text-gray-600 bg-white focus:outline-none focus:ring-1 focus:ring-blue-300"
          >
            {availableYears.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase tracking-wide">
              <th className="px-4 py-2 text-left font-medium">Date</th>
              <th className="px-4 py-2 text-left font-medium">Opponent</th>
              <th className="px-4 py-2 text-right font-medium">BF</th>
              <th className="px-4 py-2 text-right font-medium">H</th>
              <th className="px-4 py-2 text-right font-medium">BB</th>
              <th className="px-4 py-2 text-right font-medium">K</th>
              <th className="px-4 py-2 text-right font-medium">HR</th>
              <th className="px-4 py-2 text-right font-medium">wOBA</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {games.map((g) => (
              <tr
                key={g.contest_id}
                onClick={() => navigate(`/games/${g.year}/${g.contest_id}`)}
                className="hover:bg-blue-50 cursor-pointer transition-colors"
              >
                <td className="px-4 py-2 text-gray-600 whitespace-nowrap">{g.date}</td>
                <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                  {g.is_home === false ? "@ " : "vs "}
                  {g.opponent_name || g.opponent_id || "—"}
                </td>
                <td className="px-4 py-2 text-right text-gray-700">{g.bf ?? "—"}</td>
                <td className="px-4 py-2 text-right text-gray-700">{g.h ?? "—"}</td>
                <td className="px-4 py-2 text-right text-gray-700">{g.bb ?? "—"}</td>
                <td className="px-4 py-2 text-right text-gray-700">{g.k ?? "—"}</td>
                <td className="px-4 py-2 text-right text-gray-700">{g.hr ?? "—"}</td>
                <td className="px-4 py-2 text-right font-medium text-gray-800">
                  {fmt(g.woba_against)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
});

PitcherGameLog.displayName = "PitcherGameLog";
